import authService from "../../../auth/AuthService";
import {addEditDPSourceActionTypes} from "../constants/AddEditActionConstants";

const updatedDPSource = () => ({
    type: addEditDPSourceActionTypes.UPDATED_DP_SOURCE_REFRESH,
});

const toggleConsentField = (name) => ({
    type: addEditDPSourceActionTypes.TOGGLE_CONSENT_VALUE,
    payload: name
});

const validateDPSourceForm = (sourceObject, resourceType, toDelete, authToken) => ({
    type: addEditDPSourceActionTypes.VALIDATE_DP_SOURCE_FORM,
    payload: { sourceObject, resourceType, toDelete, authToken }
});

const updateSourceDetails = ({name, value}) => ({
    type: "UPDATE_SOURCE_DETAIL",
    payload: {name, value}
})

const updateSDDropdowns = ({name, change_obj}) => ({
    type: "UPDATE_SD_DROPDOWNS",
    payload: {name, change_obj}
});

const updateNotesForSource = ({name, value}) => ({
    type: "UPDATE_NOTES",
    payload: {name, value}
});

const setResultType = ({value, change_obj}) => ({
    type: "UPDATE_RESULT_TYPE",
    payload: {value, change_obj}
});


const setAssociatedServiceOption = ({ service }) => ({
    type: addEditDPSourceActionTypes.SETTING_ASSOCIATED_SERVICE_OPTION,
    payload: { service }
});

const setAssociatedCountryOption = ({ country }) => ({
    type: addEditDPSourceActionTypes.SETTING_ASSOCIATED_COUNTRY_OPTION,
    payload: { country }
});

const addVerifiableInputsValue = (inputsArr) => ({
    type: addEditDPSourceActionTypes.ADDING_VERIFIABLE_INPUT,
    payload: inputsArr
});

const deleteVerifiableInputsValue = ({value}) => ({
    type: addEditDPSourceActionTypes.DELETING_VERIFIABLE_INPUT,
    payload: {value}
});

export function toggleConsentFieldValues(name) {
    return (dispatch) => {
        dispatch(toggleConsentField(name));
    }
}

export function validateDPSource(sourceObject, resourceType, toDelete) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(validateDPSourceForm(sourceObject, resourceType, toDelete, authToken))
    }
}

export function updatedDPSourceRefresh() {
    return (dispatch) => {
        dispatch(updatedDPSource());
    }
}

export function updateSourceDetail({name, value}) {
    return (dispatch) => {
        dispatch(updateSourceDetails({name, value}))
    }
}

export function updateSourceDetailDropdowns({name, change_obj}) {
    return (dispatch) => {
        dispatch(updateSDDropdowns({name, change_obj}))
    }
}

export function updateNotesFieldForSource({name, value}) {
    return (dispatch) => {
        dispatch(updateNotesForSource({name, value}))
    }
}

export function setAssociatedServiceOptionValue({ service }) {
    return (dispatch) => {
        dispatch(setAssociatedServiceOption({ service }))
    }
}

export function setAssociatedCountryOptionValue({ country }) {
    return (dispatch) => {
        dispatch(setAssociatedCountryOption({ country }))
    }
}

export function updateResultType({value, change_obj}) {
    return (dispatch) => {
        dispatch(setResultType({value, change_obj}))
    }
}

export function deleteVerifiableInput({value}) {
    return (dispatch) => {
        dispatch(deleteVerifiableInputsValue({value}));
    }
}

export function addVerifiableInputs(inputsArr) {
    return (dispatch) => {
        dispatch(addVerifiableInputsValue(inputsArr));
    }
}

